import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.push.js";
import { defineComponent, computed } from 'vue';
import { useStore, mapState, mapGetters } from 'vuex';
import { isAndroidNative as isAndroid, isIOSNative as isIOS, sendMessage } from '@xunlei/universal-native-api';
import { usePluginMall, pluginButton, inProgressText } from '@shared/composable/plugin-mall';
import Fail from '@remote/components/Fail.vue';
import Spin from '@remote/components/Spin.vue';
import PluginItem from '@remote/components/PluginItem.vue';
import PluginGuide from '@remote/components/PluginGuide.vue';
import { defaultPluginImg } from '@remote/constant';
import { getPluginApp, getPluginStatus, deleteStatus, actionPlugin } from '@remote/api/plugin-mall';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/scrollbar/scrollbar.min.css';
import { parseVersionToNumber } from '@shared/utils';
import { useEnvStore } from '@remote/store/env';
import { useDeviceStore } from '@remote/store/device';
export default defineComponent({
  components: {
    PluginItem,
    PluginGuide,
    Swiper,
    SwiperSlide,
    Spin,
    Fail
  },
  setup() {
    const store = useStore();
    const deviceStore = useDeviceStore();
    const space = computed(() => {
      var _store$state;
      return store === null || store === void 0 || (_store$state = store.state) === null || _store$state === void 0 ? void 0 : _store$state.space;
    });
    const {
      pollPlugin,
      pluginData,
      clearAppTimer
    } = usePluginMall({
      space,
      getPluginApp,
      getPluginStatus,
      deleteStatus,
      showError: error => {
        if (error && typeof error === 'string') {
          store.commit('toast', error);
        }
      }
    });
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
      space,
      store,
      pollPlugin,
      pluginData,
      clearAppTimer
    };
  },
  data() {
    return {
      uninstallApp: {},
      uninstallIndex: 0,
      isLoading: false
    };
  },
  computed: {
    ...mapState(['action', 'loading', 'deviceInfoWatchData']),
    ...mapGetters(['isVip']),
    pluginsNum() {
      return this.pluginData.length;
    },
    bannerShowList() {
      return Array(this.bannerData.length).fill(false);
    },
    status() {
      var _deviceStore$currentD;
      const deviceStore = useDeviceStore();
      return ((_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.runnerTaskRef.phase) === 'PHASE_TYPE_RUNNING';
    },
    bannerData() {
      const defaultImg = {
        preview: defaultPluginImg,
        url: ''
      };
      try {
        return this.deviceInfoWatchData.plugin_banner ? this.deviceInfoWatchData.plugin_banner.h5 : [defaultImg];
      } catch (error) {
        return [defaultImg];
      }
    },
    installPlugins() {
      return this.pluginData.filter(plugin => plugin.pluginStatus);
    },
    installNum() {
      return this.installPlugins.length;
    },
    installName() {
      return this.installPlugins.reduce((pre, cur) => `${pre}${encodeURIComponent(cur.name)};`, '');
    },
    startupPlugins() {
      return this.pluginData.filter(plugin => plugin.statusPhaseDesc === '打开');
    },
    startupNum() {
      return this.startupPlugins.length;
    },
    startName() {
      return this.startupPlugins.reduce((pre, cur) => `${pre}${encodeURIComponent(cur.name)};`, '');
    }
  },
  watch: {
    action(val) {
      if (val === 'plugin') {
        this.store.commit('dialog', {
          show: false
        });
      } else if (val === 'uninstall') {
        this.handleUninstall();
      }
    }
  },
  async mounted() {
    document.title = '小工具';
    await this.pollPlugin();
    this.pageShow();
  },
  methods: {
    onSwiper() {
      console.log('swiper');
    },
    onSlideChange(swiper) {
      let index = swiper.activeIndex;
      index === 0 ? index = this.bannerShowList.length : index === this.bannerShowList.length + 1 ? index = 1 : '';
      if (!this.bannerShowList[index - 1]) {
        this.$stat({
          action: 'smallplug_page_banner_show',
          data: {
            banner_name: this.bannerData[index - 1].name
          }
        });
        this.bannerShowList[index - 1] = true;
      }
    },
    goToDoc(item) {
      const url = item.url.trim();
      const envStore = useEnvStore();
      if (url) {
        this.$stat({
          action: 'smallplug_page_banner_click',
          data: {
            banner_name: item.name
          }
        });
        if (isAndroid) {
          return sendMessage({
            platform: 'android',
            name: 'xlOpenUrl',
            params: {
              url,
              openType: 1,
              from: ''
            }
          });
        } else if (isIOS) {
          this.isLoading = true;
          setTimeout(() => {
            this.isLoading = false;
            location.assign(`xunlei://hybrid/openHybridWeb?url=${decodeURIComponent(url)}`);
          }, 1000);
        } else if (envStore.isInPC) {
          if (window.native) {
            window.native.CallNativeFunction('OpenNewTab', url);
          }
        } else if (envStore.isInMac) {
          window.WebViewJavascriptBridge.callHandler('openURL', {
            url
          }, function (err) {
            if (err) {
              console.log(err.message);
            }
          });
        } else {
          this.$router.push({
            name: 'pluginIframe',
            query: {
              ...this.$route.query,
              currentIframeUrl: url,
              currentIframeTitle: ' ',
              currentIframeShowClose: 0
            }
          });
        }
      }
    },
    handleUninstall() {
      this.store.commit('dialog', {
        show: false
      });
      this.handelPluginChange('卸载', this.uninstallApp, this.uninstallIndex);
    },
    async pageShow() {
      this.$stat({
        action: 'smallplug_page_show',
        data: {
          plug_num: this.pluginsNum,
          install_plug_num: this.installNum,
          install_plug_name: this.installName,
          launch_plug_num: this.startupNum,
          launch_plug_name: this.startName
        }
      });
    },
    handlePluginClick(action, pluginItem, index) {
      pluginItem.showAction = false;
      if (action === pluginButton.OPEN) {
        var _pluginItem$version$r, _pluginItem$version, _pluginItem$version$r2;
        // 050db57e2d73ac45c239beba432a2f95: 网心云
        // b514f2f26975b198cc1f7bf07118710f: 网心云arm64
        // 03d0d715ff47b12aa1fa582e8d8741f3: 网心云测试用
        if (['050db57e2d73ac45c239beba432a2f95', 'b514f2f26975b198cc1f7bf07118710f', '03d0d715ff47b12aa1fa582e8d8741f3'].includes(pluginItem.id) && parseVersionToNumber((_pluginItem$version$r = pluginItem === null || pluginItem === void 0 || (_pluginItem$version = pluginItem.version) === null || _pluginItem$version === void 0 || (_pluginItem$version$r2 = _pluginItem$version.replace) === null || _pluginItem$version$r2 === void 0 ? void 0 : _pluginItem$version$r2.call(_pluginItem$version, 'v', '')) !== null && _pluginItem$version$r !== void 0 ? _pluginItem$version$r : '') < parseVersionToNumber('2.3.19')) {
          this.store.commit('dialog', {
            show: true,
            title: '温馨提示',
            tip: '您的插件版本过低，为保证您的使用体验，请您升级到最新版本',
            okTxt: '我知道了',
            cancelTxt: '',
            action: 'plugin',
            showLoader: false
          });
        } else {
          this.$stat({
            action: 'smallplug_page_plug_click',
            data: {
              plug_name: pluginItem.name,
              launch_status: pluginItem.pluginStatus === 'running',
              btn_status: 'open',
              click_id: 'open'
            }
          });
          this.$router.push({
            name: 'pluginIframe',
            query: {
              ...this.$route.query,
              currentIframeUrl: pluginItem.link,
              // 隐藏「网速测试」插件的头部。 fixing: http://jira.xunlei.cn/browse/NAS-2949
              // 网速测试 插件id: 6a7ce3356c4740946df70760d8fa97bd
              // 网速测试arm版 插件id: e992af9a955024e7354ef6937b8fb40e
              currentIframeTitle: ['e992af9a955024e7354ef6937b8fb40e', '6a7ce3356c4740946df70760d8fa97bd'].includes(pluginItem.id) ? '' : pluginItem.name,
              currentIframeShowClose: 1
            }
          });
        }
      } else if (action === pluginButton.UNINSTALL) {
        this.uninstallApp = pluginItem;
        this.uninstallIndex = index;
        this.store.commit('dialog', {
          show: true,
          title: '确定卸载该插件吗',
          tip: '',
          okTxt: '确认',
          cancelTxt: '取消',
          action: 'uninstall',
          showLoader: false
        });
      } else {
        this.handelPluginChange(action, pluginItem, index);
      }
    },
    handelPluginChange(status, app, index) {
      if (app.diabled) return;
      let reStatus = '';
      let inProgress = 'not-in-progress';
      let action = '';
      let click_id = '';
      let click_result = '';
      let btn_status = '';
      switch (status) {
        case pluginButton.INSTALL:
          reStatus = pluginButton.IN_INSTALL;
          inProgress = inProgressText.IN_PERCENT;
          action = 'install';
          click_id = 'install';
          click_result = 'install_success';
          btn_status = 'install';
          break;
        case pluginButton.RUN:
          reStatus = pluginButton.IN_RUN;
          inProgress = inProgressText.IN_PROGRESS;
          action = 'run';
          click_result = 'launch_success';
          btn_status = 'launch';
          break;
        case pluginButton.STOP:
          reStatus = pluginButton.IN_STOP;
          inProgress = inProgressText.IN_PROGRESS;
          click_id = 'stop';
          action = 'stop';
          btn_status = 'stop';
          click_result = 'stop_success';
          break;
        case pluginButton.UNINSTALL:
          reStatus = pluginButton.IN_UNINSTALL;
          inProgress = inProgressText.IN_PROGRESS;
          click_id = 'uninstall';
          action = 'uninstall';
          click_result = 'uninstall_success';
          btn_status = 'uninstall';
          break;
        case pluginButton.UPDATE:
          reStatus = pluginButton.IN_UPDATE;
          inProgress = inProgressText.IN_PERCENT;
          action = 'update';
          btn_status = 'uninstall';
          click_result = 'update_success';
          break;
        case pluginButton.CLEAN:
          reStatus = pluginButton.IN_CLEAN;
          inProgress = inProgressText.IN_PROGRESS;
          click_id = 'move';
          action = 'clean';
          btn_status = 'move';
          click_result = 'move_success';
          break;
      }
      if (action == '') return;
      this.$stat({
        action: 'smallplug_page_plug_click',
        data: {
          plug_name: app.name,
          launch_status: app.pluginStatus === 'running',
          btn_status,
          click_id
        }
      });
      let params = {
        file_name: app.name,
        name: app.name,
        file_size: '0',
        type: 'user#app',
        space: this.space,
        params: {
          target: this.space,
          app_id: app.id,
          action
        }
      };
      this.pluginData[index].statusPhaseDesc = reStatus;
      this.pluginData[index].inProgress = inProgress;
      this.pluginData[index].progress = 0;
      actionPlugin(params).then(() => {
        this.pollPlugin();
        setTimeout(() => {
          this.$stat({
            action: 'smallplug_page_plug_click_result',
            data: {
              plug_name: app.name,
              launch_status: app.pluginStatus === 'running',
              result: click_result
            }
          });
        }, 1000);
      });
    }
  }
});